import React from "react";
import { CCol, CRow } from "@coreui/react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

// Validation schema using Yup
const validationSchema = Yup.object({
  full_name: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  position_application: Yup.string().required("Position Application is required"),
  how_you_find_us: Yup.string().required("Please tell us how you found us"),
  about_yourself: Yup.string().required("About Yourself is required"),
  resume: Yup.mixed().required("Resume is required"),
  doc: Yup.mixed().required("Documents are required"),
});

export default function FeedbackForm() {
  // Handle form submission
  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();
    formData.append("full_name", values.full_name);
    formData.append("email", values.email);
    formData.append("position_application", values.position_application);
    formData.append("how_you_find_us", values.how_you_find_us);
    formData.append("about_yourself", values.about_yourself);
    formData.append("resume", values.resume);
    formData.append("doc", values.doc);

    axios
      .post("https://erp.rplconsultants.com.au/api/teams", formData)
      .then((response) => {
        // On success, show alert and reset form
        alert("Your application has been submitted successfully!");
        resetForm();
      })
      .catch((error) => {
        // Handle error
        console.error("Error submitting form:", error);
        alert("There was an error submitting your application. Please try again.");
      });
  };

  return (
    <Formik
      initialValues={{
        full_name: "",
        email: "",
        position_application: "",
        how_you_find_us: "",
        about_yourself: "",
        resume: null,
        doc: null,
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, setFieldValue }) => (
        <Form>
          <CRow>
            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="full_name"
                  placeholder="Full Name"
                  value={values.full_name || ""}
                  onChange={handleChange}
                />
                <ErrorMessage name="full_name" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="email"
                  name="email"
                  placeholder="Email address"
                  value={values.email || ""}
                  onChange={handleChange}
                />
                <ErrorMessage name="email" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  type="text"
                  name="position_application"
                  placeholder="Position Application"
                  value={values.position_application || ""}
                  onChange={handleChange}
                />
                <ErrorMessage name="position_application" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <Field as="select" name="how_you_find_us" value={values.how_you_find_us || ""} onChange={handleChange}>
                  <option value="">How You Find Us?</option>
                  <option value="online">Online</option>
                  <option value="friends">Friends</option>
                  <option value="advertisement">Advertisement</option>
                  <option value="other">Other</option>
                </Field>
                <ErrorMessage name="how_you_find_us" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={12} className="mb-3">
              <div className="form-input-wrapper">
                <Field
                  as="textarea"
                  name="about_yourself"
                  rows={5}
                  placeholder="About Yourself"
                  value={values.about_yourself || ""}
                  onChange={handleChange}
                />
                <ErrorMessage name="about_yourself" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Please attach Resume</label>
                <input
                  type="file"
                  name="resume"
                  onChange={(e) => setFieldValue("resume", e.target.files[0])}
                />
                <ErrorMessage name="resume" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={6} className="mb-3">
              <div className="form-input-wrapper">
                <label>Please attach Documents and other Qualifications</label>
                <input
                  type="file"
                  name="doc"
                  onChange={(e) => setFieldValue("doc", e.target.files[0])}
                />
                <ErrorMessage name="doc" component="div" className="error-message" />
              </div>
            </CCol>

            <CCol lg={12} className="mt-4">
              <div className="form-submit">
                <button type="submit" className="theme-primary-btn w-100">
                  Join Our Team
                </button>
              </div>
            </CCol>
          </CRow>
        </Form>
      )}
    </Formik>
  );
}
